import { useEffect } from 'react';
import { companyFromLink, hasSeveralCompanies, withoutCompanyParam } from './companies';
import { getCompanyId } from './companySession';
import { cachedMyCompanies, refreshMyCompanies } from './myCompaniesCache';
import { switchCompany } from './switchCompany';

/**
 * Links that carry `?company=<id>` (emails, push taps, vendor-reply redirects)
 * open in that company: the tab switches first, when the person belongs to it.
 * A person with one company is never switched — the parameter is just dropped.
 */
export default function useCompanyLink({ location, navigate, token, store, persistor, socket }) {
  useEffect(() => {
    if (!token || !new URLSearchParams(location.search).has('company')) return;
    let cancelled = false;
    (async () => {
      const myCompanies = cachedMyCompanies() ?? (await refreshMyCompanies());
      if (cancelled) return;
      const target = companyFromLink(location.search, myCompanies);
      const cleanUrl = location.pathname + withoutCompanyParam(location.search) + location.hash;
      if (!target || !hasSeveralCompanies(myCompanies) || target === getCompanyId()) {
        navigate(cleanUrl, { replace: true });
        return;
      }
      await switchCompany(target, { store, persistor, socket, destination: cleanUrl });
    })().catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [location.search, token]);
}
